module.exports = __webpack_public_path__ + "static/media/1_en.adffc7c2.png";